// tableViewSync.js

const serializeKeyList = (keys) => JSON.stringify(keys || []);

const serializeWidthMap = (widths) => {
    const ordered = Object.keys(widths || {})
        .sort()
        .reduce((acc, key) => {
            acc[key] = widths[key];
            return acc;
        }, {});
    return JSON.stringify(ordered);
};

const buildViewSyncPayload = ({
    hasExplicitProperties,
    fieldKeys,
    visibleFieldKeys,
    viewColumnWidths,
    normalizedColumnWidths,
}) => {
    const payload = {};
    let propertiesChanged = false;
    let widthsChanged = false;

    if (Array.isArray(fieldKeys) && Array.isArray(visibleFieldKeys)) {
        propertiesChanged = serializeKeyList(fieldKeys) !== serializeKeyList(visibleFieldKeys);
        if (propertiesChanged && hasExplicitProperties) {
            payload.properties = visibleFieldKeys.length ? visibleFieldKeys : null;
        }
    }

    if (viewColumnWidths && normalizedColumnWidths) {
        widthsChanged = serializeWidthMap(viewColumnWidths) !== serializeWidthMap(normalizedColumnWidths);
        if (widthsChanged) {
            payload.columnWidths = Object.keys(normalizedColumnWidths).length
                ? normalizedColumnWidths
                : null;
        }
    }

    return {
        payload,
        propertiesChanged,
        widthsChanged,
    };
};

export {
    buildViewSyncPayload,
    serializeKeyList,
    serializeWidthMap,
};
